export class CreateTipoSelladoRequest {
    
    public descripcion : string="";
    public valor : number=0;
}